import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type MascotBadgeProps = {
  src: string;
  alt: string;
};

// Small circular mascot badge with a "Hi!" speech bubble.
export function MascotBadge({
  src,
  alt
}: MascotBadgeProps) {
  const reduceMotion = useReducedMotion();
  return <div className="flex items-center gap-3" data-id="element-353" data-mp="10bc7pancscd7">
      <motion.div className="relative h-24 w-24 shrink-0 overflow-hidden rounded-full bg-white ring-4 ring-[#E3C77F] shadow-[0_12px_30px_-10px_rgba(0,0,0,0.6)] sm:h-28 sm:w-28" animate={reduceMotion ? undefined : {
      rotate: [0, -4, 4, -2, 0]
    }} transition={{
      duration: 2.4,
      repeat: Infinity,
      repeatDelay: 2,
      ease: 'easeInOut'
    }} data-id="element-354" data-mp="10aix1yl9x2ps">
        <img src={src} alt={alt} className="absolute left-[-6%] top-[-4%] w-[165%] max-w-none select-none" draggable={false} data-id="element-355" data-mp="1jzl11o0muoea" />
      </motion.div>
      <motion.span initial={{
      opacity: 0,
      scale: 0.7
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.5,
      type: 'spring',
      stiffness: 260,
      damping: 16
    }} className="relative rounded-2xl bg-white px-4 py-2 font-display text-xl font-semibold text-forest shadow-lg" data-id="element-356" data-mp="1t118po02ccet">
        <span aria-hidden="true" className="absolute -left-1.5 top-1/2 h-3 w-3 -translate-y-1/2 rotate-45 bg-white" data-id="element-357" data-mp="10ej77v8ovlly" />
        <span className="relative" data-id="element-358" data-mp="14ir0m5q3dpqi">Hi!</span>
      </motion.span>
    </div>;
}